module.exports = __webpack_public_path__ + "f7746e7abef0222ed39a52df50570ca7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-27.png
// module id = 2075
// module chunks = 0